import { LOCALE } from "@similar/utils-tools";
export const judgeClient = () => {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
  const isIOS = !!u.match(/iPhone/); //判断是否是 iOS终端
  console.log("是否是Android：" + isAndroid); //true,false
  console.log("是否是iOS：" + isIOS);
  if (isAndroid) {
    return "android";
  } else if (isIOS) {
    return "ios";
  } else {
    return "unknow";
  }
};

const client = judgeClient();

export const platform = {
  ios: client === "ios",
  android: client === "android",
};

// export const LOCALE = LOCALE;

export const FLIPOVER_LANGUAGE = "ar";

export const dynamicImportLocale = async () => {
  const language = LOCALE;

  let message = {};

  switch (language) {
    case "en":
      message = (await import("../locale/en")).default;
      break;
    case "zh":
      message = (await import("../locale/zh")).default;
      break;
    case "ar":
      message = (await import("../locale/ar")).default;
      break;
    case "id":
      message = (await import("../locale/id")).default;
      break;
    case "tr":
      message = (await import("../locale/tr")).default;
      break;
    case "fil":
      message = (await import("../locale/fil")).default;
      break;
    case "th":
      message = (await import("../locale/th")).default;
      break;
    case "es":
      message = (await import("../locale/es")).default;
      break;
    case "pt":
      message = (await import("../locale/pt")).default;
      break;
    case "ms":
      message = (await import("../locale/ms")).default;
      break;
    default:
      message = (await import("../locale/en")).default;
      break;
  }

  return { language, message };
};
